export const LOAD_COCKTAILS = "LOAD_COCKTAILS";
export const LOAD_INGREDIENTS = "LOAD_INGREDIENTS";
export const LOAD_GLASSES = "LOAD_GLASSES";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const ACTIVATE_FILTER_DIALOG = "ACTIVATE_FILTER_DIALOG";
export const CLOSE_FILTER_DIALOG = "CLOSE_FILTER_DIALOG";
export const SET_BAR = "SET_BAR";
export const UPDATE_FAVOURITES = "UPDATE_FAVOURITES";
export const ADD_TO_BAR = "ADD_TO_BAR";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const TOGGLE_PRIDE = "TOGGLE_PRIDE";
export const TOGGLE_LINGO = "TOGGLE_LINGO";
export const START_ENRICH_COCKTAIL = "START_ENRICH_COCKTAIL";
export const FAIL_ENRICH_COCKTAIL = "FAIL_ENRICH_COCKTAIL";
export const FINISH_ENRICH_COCKTAIL = "FINISH_ENRICH_COCKTAIL";
